export const OfficeFlexjobState = {
	url: '/flexjobs',
	title: 'Office Flexjobs List',
	template: '<flexjobs-page></flexjobs-page>',
	lazyLoad: $transition$ => {
		const $ocLazyLoad = $transition$.injector().get('$ocLazyLoad');
		const $log = $transition$.injector().get('$log');
		return import(
			/* webpackChunkName: "officeFlexjobsPageMod" */
			'@Containers/office-flexjobs-page/office-flexjobs-page.cmp.js'
		)
			.then(res => $ocLazyLoad.load({name: res.default}))
			.catch(err => $log.error(err));
	},
};
